import moment from 'moment';

export function getToday() {
    const date = new Date();
    const today = `${date.getDate()}-${parseInt(date.getMonth() + 1, 10)}-${date.getFullYear()}`
    const time = `${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}`;
    return { today, time }
}

export function isDateBeforeToday(date) {
    return date > moment().endOf('day');
}

export function isDateBefore20Dates(date) {
    const twentyDaysBeforeToday = moment().subtract(20, 'days').startOf('day');
    return date.isAfter(twentyDaysBeforeToday);
}